import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { TmCalc } from "../components/TmCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.tm_tool_name()}
        toolPath="/tm-calculator"
      />
      <SciHeader title={m.tm_h1()} intro={m.tm_intro()} />

      <TmCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.tm_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.tm_ex1(), m.tm_ex2(), m.tm_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.tm_faq_q1(), a: m.tm_faq_a1() },
          { q: m.tm_faq_q2(), a: m.tm_faq_a2() },
          { q: m.tm_faq_q3(), a: m.tm_faq_a3() },
          { q: m.tm_faq_q4(), a: m.tm_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
